import Chart from 'chart.js'

export default class FumDistributionDonutChart {
  constructor() {
    const ctx = document
      .getElementById('fum-distribution-donut')
      .getContext('2d')
    this.chartDonut = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              'rgba(42, 10, 78, 1.0)',
              'rgba(42, 10, 78, 0.8)',
              'rgba(42, 10, 78, 0.6)',
              'rgba(42, 10, 78, 0.4)',
              'rgba(42, 10, 78, 0.3)',
              'rgba(42, 10, 78, 0.2)',
              'rgba(42, 10, 78, 0.1)',
              'rgba(42, 10, 78, 0.06)',
              'rgba(42, 10, 78, 0.04)'
            ],
            borderColor: '#fff',
            borderWidth: 1,
            hoverBackgroundColor: [
              '#2a0a4e',
              '#543b71',
              '#7f6c94',
              '#a99db8',
              '#bfb5ca',
              '#d4cedb',
              '#eae6ed',
              '#f1edf4',
              '#f4eff7'
            ],
            hoverBorderColor: '#fff',
            hoverBorderWidth: 1
          }
        ]
      },
      options: {
        cutoutPercentage: 45,
        legend: { display: false },
        tooltips: {
          enabled: false,
          custom: setToolTip,
          callbacks: { label: setToolTipLabel }
        },
        responsive: true,
        maintainAspectRatio: false
      },
      plugins: [
        {
          beforeUpdate: (chart, easing) => {
            let numOfData = chart.data.datasets[0].data.length
            let backgroundColors = [
              createGrad('rgba(42, 10, 78, 1)'),
              createGrad('rgba(84, 59, 113, 1)'),
              createGrad('rgba(127, 108, 148, 1)'),
              createGrad('rgba(169, 157, 184, 1)'),
              createGrad('rgba(191, 181, 202, 1)'),
              createGrad('rgba(212, 206, 219, 1)'),
              createGrad('rgba(234, 230, 237, 1)'),
              createGrad('rgba(241, 237, 244, 1)'),
              createGrad('rgba(244, 239, 247, 1)')
            ]
            if (numOfData > 10) {
              for (let i = 10; i < numOfData; i++) {
                backgroundColors.push(createGrad('rgba(234, 230, 237, 1)'))
              }
            }
            chart.data.datasets[0].backgroundColor = backgroundColors
          }
        }
      ]
    })
  }

  updateFumDistributionData(data) {
    data.sort((a, b) => {
      return parseFloat(Object.values(b)[0]) - parseFloat(Object.values(a)[0])
    })
    const labels = data.map(x => Object.keys(x))
    const dataset = data.map(x => {
      let value = Number(Object.values(x))
      if (value < 0) {
        value = 0
      }
      return value
    })
    this.chartDonut.data.labels = labels
    this.chartDonut.data.datasets[0].label = labels
    this.chartDonut.data.datasets[0].data = Object.values(dataset)
    this.chartDonut.update()

    const legend = document.querySelector('.fum-distribution__legend')
    const total = dataset.reduce((acc, cur) => acc + cur)
    data.forEach((x, i) => {
      legend.innerHTML += `
      <div class="fum-distribution__legend--item" id="legend-${i}">
        <span class="fum-distribution__legend--box"></span>
        <span class="fum-distribution__legend--title">${Object.keys(x)}</span>
        <span class="fum-distribution__legend--value">\
        $${Number(Object.values(x)).toLocaleString(undefined, {
          maximumFractionDigits: 0
        })}</span>
        <span class="fum-distribution__legend--percentage">\
        ${Math.round((parseFloat(Object.values(x)) / total) * 100, 0)}%</span>
      </div>
      `
    })
  }

  tooltipListen() {
    let legendItems = document.querySelectorAll(
      '.fum-distribution__legend--item'
    )
    legendItems.forEach(el => {
      el.addEventListener('mouseenter', e => {
        const index = e.target.id.replace('legend-', '')
        openTip(this.chartDonut, 0, index)
      })

      el.addEventListener('mouseleave', e => {
        const index = e.target.id.replace('legend-', '')
        closeTip(this.chartDonut, 0, index)
      })
    })
  }
}

function openTip(chart, datasetIndex, pointIndex) {
  if (chart.tooltip._active == undefined) chart.tooltip._active = []
  let activeElements = chart.tooltip._active
  let requestedElem = chart.getDatasetMeta(datasetIndex).data[pointIndex]
  for (let i = 0; i < activeElements.length; i++) {
    if (requestedElem._index == activeElements[i]._index) return
  }
  activeElements.push(requestedElem)
  chart.tooltip._active = activeElements
  chart.tooltip.update(true)
  chart.draw()
}

function closeTip(chart, datasetIndex, pointIndex) {
  let activeElements = chart.tooltip._active
  if (activeElements == undefined || activeElements.length == 0) return
  let requestedElem = chart.getDatasetMeta(datasetIndex).data[pointIndex]
  for (let i = 0; i < activeElements.length; i++) {
    if (requestedElem._index == activeElements[i]._index) {
      activeElements.splice(i, 1)
      break
    }
  }
  chart.tooltip._active = activeElements
  chart.tooltip.update(true)
  chart.draw()
}

const createGrad = color => {
  let cover
  const ctx = document.getElementById('fum-distribution-donut').getContext('2d')
  let canvasWidth = document
    .getElementById('fum-distribution-donut')
    .getBoundingClientRect().width
  let canvasHeight = document
    .getElementById('fum-distribution-donut')
    .getBoundingClientRect().height

  const white = 'rgba(255, 255, 255, 1.0)'

  cover = ctx.createRadialGradient(
    canvasWidth / 2,
    canvasHeight / 2,
    0,
    canvasWidth / 2,
    canvasHeight / 2,
    canvasHeight / 2 - 10
  )
  cover.addColorStop(0.0, color)
  cover.addColorStop(0.99, color)
  cover.addColorStop(0.99, color)
  cover.addColorStop(1, white)
  return cover
}

const percentage = (tooltip, data) => {
  let total = data.datasets[0].data.reduce((acc, cur) => {
    return Number(acc) + Number(cur)
  })
  let percentage = (data.datasets[0].data[tooltip.index] / total) * 100
  percentage = Math.round(percentage)
  return percentage
}

const setToolTipLabel = (tooltip, data) => {
  const legendItems = document.querySelectorAll(
    '.fum-distribution__legend--item'
  )

  legendItems.forEach(el => {
    el.classList.remove('active')
  })
  const legendItem = document.getElementById('legend-' + tooltip.index)
  legendItem.classList.add('active')
  const legendItemBox = legendItem.querySelector(
    '.fum-distribution__legend--box'
  )
  legendItemBox.style.backgroundColor =
    data.datasets[0].hoverBackgroundColor[tooltip.index]

  const tooltipEl = document.getElementById(
    'fum-distribution-donut-chartjs-tooltip'
  )
  const chart = document.getElementById('fum-distribution-donut')
  tooltipEl.style.top =
    legendItemBox.getBoundingClientRect().bottom +
    window.scrollY -
    (chart.getBoundingClientRect().top + window.scrollY) +
    'px'

  return `<div class="tooltip__percentage">${percentage(tooltip, data)}%</div>`
}

const setToolTip = tooltip => {
  // Tooltip Element
  const tooltipEl = document.getElementById(
    'fum-distribution-donut-chartjs-tooltip'
  )

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    const legendItems = document.querySelectorAll(
      '.fum-distribution__legend--item'
    )
    legendItems.forEach(el => {
      el.classList.remove('active')
    })
    tooltipEl.style.opacity = 0
    return
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  function getBody(bodyItem) {
    return bodyItem.lines
  }

  // Set Text
  if (tooltip.body) {
    var bodyLines = tooltip.body.map(getBody)

    var innerHtml = `<div>
      <div class="tooltip__body">`
    bodyLines.forEach((body, i) => {
      innerHtml += `<div class="tooltip__body--text">${body}</div>`
    })
    innerHtml += '</div></div>'

    tooltipEl.innerHTML = innerHtml
  }

  tooltipEl.style.opacity = 1
  tooltipEl.style.left = 0
  tooltipEl.style.width = tooltip.caretX + 'px'
  tooltipEl.style.bottom = 240 - tooltip.caretY + 'px'
}



// WEBPACK FOOTER //
// ./assets/j/src/charts/fum_distribution.js